import { ActionTypes } from "@/App/constants/actionTypes";
import { GroupTypes } from "@/types";

type GetGroupAction = {
  type: typeof ActionTypes.GET_GROUP;
  payload: string;
};

export const getGroup = (id: string): GetGroupAction => {
  return {
    type: ActionTypes.GET_GROUP,
    payload: id,
  };
};

type GetGroupResultsAction = {
  type: typeof ActionTypes.GET_GROUP_RESULTS;
  payload: GroupTypes.Group;
};

export const getGroupResults = (data: GroupTypes.Group): GetGroupResultsAction => {
  return {
    type: ActionTypes.GET_GROUP_RESULTS,
    payload: data,
  };
};

type ClearGroupAction = {
  type: typeof ActionTypes.CLEAR_GROUP;
};

export const clearGroup = (): ClearGroupAction => {
  return {
    type: ActionTypes.CLEAR_GROUP,
  };
};

export type GroupGetActions = GetGroupAction | GetGroupResultsAction | ClearGroupAction;
